module.exports = __webpack_public_path__ + "static/team-1-6199a2ce6421905f001e3046c02bf336.jpg";